export type { SearchInputProps } from '../../../types/search-input';
export { SearchInput } from './adapters/inbound/SearchInput';
